import { Glossaries } from "@/types";
import { Button, getKeyValue } from "@nextui-org/react";
import { Key, useCallback, useState } from "react";
import { EditIcon } from "@/assets/icons/admin";
import { useGetAllGlossariesByContent } from "@/services/glossary.service";
import EditGlossary from "../editglossary";
import Datatable from "@/components/tables/datatable";
import { format } from "date-fns";

const statuses = [
  { label: "Title", value: "title" },
  { label: "Description", value: "content" },
];

const columns = [
  {
    key: "no",
    label: "No",
  },
  {
    key: "createdAt",
    label: "Created Date",
  },
  {
    key: "updatedAt",
    label: "Last Update",
  },
  {
    key: "title",
    label: "Title",
  },
  {
    key: "content",
    label: "Description",
  },

  {
    key: "action",
    label: "Action",
  },
];

function GlossaryList() {
  const query = useGetAllGlossariesByContent;

  const [isEditingGlossary, setIsEditingGlossary] = useState(false);
  const [editGlossaryItem, setEditGlossaryItem] = useState<Glossaries>();

  const handleEditClick = (item: any) => {
    setIsEditingGlossary(true);
    setEditGlossaryItem(item);
  };

  const handleCancelEditGlossary = () => {
    setIsEditingGlossary(false);
    setEditGlossaryItem(undefined);
  };

  const renderCell = useCallback((data: any[], item: any, columnKey: Key) => {
    switch (columnKey) {
      case "no":
        return (
          <div className="font-openSans text-sm font-bold">
            {" "}
            {data.findIndex((row) => (row as any)?.id === (item as any)?.id) +
              1 +
              "."}
          </div>
        );
      case "action":
        return (
          <div className="flex items-center">
            <Button
              onClick={() => handleEditClick(item)}
              isIconOnly
              className="transparent-bg h-auto w-auto"
            >
              <EditIcon />
            </Button>
            {/* <Button
                                  onClick={() => handlePasswordClick(item.id)}
                                  isIconOnly
                                  className="w-auto h-auto transparent-bg"
                                >
                                  <ResetPWIcon />
                                </Button> */}
          </div>
        );
      case "userName":
        return <div className="font-bold"> {getKeyValue(item, columnKey)}</div>;
      case "createdAt":
      case "updatedAt":
        return (
          <div className="w-max">
            {format(
              getKeyValue(item, columnKey) || new Date(),
              "dd/MM/yyyy HH:mm:ss",
            )}
          </div>
        );
      default:
        return (
          <div className="font-normal">
            {getKeyValue(item, columnKey as string) || "-"}
          </div>
        );
    }
  }, []);

  return (
    <div>
      {isEditingGlossary ? (
        <EditGlossary
          onCancel={handleCancelEditGlossary}
          itemData={editGlossaryItem!}
        />
      ) : (
        <div>
          <div className="font-ubuntu float-left text-center text-2xl font-semibold text-white">
            <p className="hidden sm:block">Glossary List</p>
          </div>

          <Datatable
            columns={columns}
            renderCell={renderCell}
            query={query}
            customQueryFilter={{
              filter: statuses,
            }}
            customFilters={[]}
            searchFields={statuses}
            customActions={
              <Button
                className="admin-common-button-gradient font-ubuntu w-[170px] rounded-md text-base font-bold"
                onClick={() => {
                  setIsEditingGlossary(true);
                }}
              >
                + Add Glossary
              </Button>
            }
          />
        </div>
      )}
    </div>
  );
}

export default GlossaryList;
